<h3 class="title configurator-title">{{ 'workbench.finishes.title' | translate }}</h3>

<ng-casto-loader *ngIf="false"></ng-casto-loader>

<!-- Chants -->
<div class="config-container shadow my-3" *ngIf="configurationCanHaveEdges()">
  <h4 class="title configurator-subtitle collapse-button" (click)="toggleCollapse(1)">
    {{ 'workbench.finishes.edge.title' | translate }}
  </h4>

  <div class="collapse-block" *ngIf="substep === 1">
    <div class="container-fluid">
      <article class="caption">
        <div class="caption-color-line edge-not-select"></div>
        <p>{{ 'workbench.finishes.edge.captions.not-select' | translate }}</p>
      </article>
      <article class="caption">
        <div class="caption-color-line edge-select"></div>
        <p>{{ 'workbench.finishes.edge.captions.select' | translate }}</p>
      </article>
    </div>
  </div>
</div>

<!-- Bord poli == Chant mais convert() vers sideCut -->
<div class="config-container shadow my-3" *ngIf="configurationCanHaveSideCuts()">
  <h4 class="title configurator-subtitle collapse-button" (click)="toggleCollapse(2)">
    {{ 'workbench.finishes.side-cut.title' | translate }}
  </h4>

  <div class="collapse-block" *ngIf="substep === 2">
    <div class="container-fluid">
      <article class="caption">
        <div class="caption-color-line side-cut-not-select"></div>
        <p>{{ 'workbench.finishes.side-cut.captions.not-select' | translate }}</p>
      </article>
      <article class="caption">
        <div class="caption-color-line side-cut-select"></div>
        <p>{{ 'workbench.finishes.side-cut.captions.select' | translate }}</p>
      </article>
    </div>
  </div>
</div>

<!-- Jambage -->
<div class="config-container shadow my-3" *ngIf="configurationCanHaveJambs()">
  <h4 class="title configurator-subtitle collapse-button" (click)="toggleCollapse(3)">
    {{ 'workbench.finishes.jamb.title' | translate }}
  </h4>

  <div class="collapse-block" *ngIf="substep === 3">
    <div class="container-fluid">
      <article class="caption">
        <div class="caption-color-line jamb-not-select"></div>
        <p>{{ 'workbench.finishes.jamb.captions.not-select' | translate }}</p>
      </article>
      <article class="caption">
        <div class="caption-color-line jamb-select"></div>
        <p>{{ 'workbench.finishes.jamb.captions.select' | translate }}</p>
      </article>
    </div>

    <ng-workbench-jambs-infos
      *ngFor="let group of getGroupsWithJambs()"
      [planOrGroup]="group"
      [collapseIsVisible]="planOrGroupIsVisible(group)"
      (onPlanOrGroupSelected)="selectGroupOrPlan(group)"></ng-workbench-jambs-infos>
    <ng-workbench-jambs-infos
      *ngFor="let plan of getPlansWithJambs()"
      [planOrGroup]="plan"
      [collapseIsVisible]="planOrGroupIsVisible(plan)"
      (onPlanOrGroupSelected)="selectGroupOrPlan(plan)"></ng-workbench-jambs-infos>
  </div>
</div>

<!-- Découpe d'angle -->
<div class="config-container shadow my-3" *ngIf="configurationCanHaveCutaway()">
  <h4 class="title configurator-subtitle collapse-button" (click)="toggleCollapse(4)">
    {{ 'workbench.finishes.cutaway.title' | translate }}
  </h4>

  <div class="collapse-block" *ngIf="substep === 4">
    <div class="container-fluid">
      <article class="caption">
        <div class="caption-color-round cutaway-not-select"></div>
        <p>{{ 'workbench.finishes.cutaway.captions.not-cut' | translate }}</p>
      </article>
      <article class="caption">
        <div class="caption-color-round cutaway-straight-select"></div>
        <p>{{ 'workbench.finishes.cutaway.captions.straight' | translate }}</p>
      </article>
      <article class="caption">
        <div class="caption-color-round cutaway-round-select"></div>
        <p>{{ 'workbench.finishes.cutaway.captions.round' | translate }}</p>
      </article>

      <div class="configurator-cards-container blocked-size mt-2">
        <div class="configurator-card not-selectable" *ngFor="let cutaway of cutaways">
          <ng-casto-img-loader
            [imgSrc]="workbenchService.apiUrl + cutaway.icon.path"
            [imgClass]="'configurator-card-img'"></ng-casto-img-loader>
          <p class="configurator-card-title">{{ cutaway.name }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Ouvertures de plan -->
<div class="config-container shadow my-3" *ngIf="configurationCanHaveCutting()">
  <h4 class="title configurator-subtitle collapse-button" (click)="toggleCollapse(5)">
    {{ 'workbench.finishes.cutting.title' | translate }}
  </h4>

  <div class="collapse-block" *ngIf="substep === 5">
    <div class="container-fluid">
      <ng-workbench-plan-cutting-infos [cuttings]="cuttings"></ng-workbench-plan-cutting-infos>
    </div>
  </div>
</div>
